module.exports = __webpack_public_path__ + "images/52ee96f45f510c80e7d53df15f360902.svg";